import styled from 'styled-components';

export const StyledInputLabel = styled.div`
  margin-bottom: 5px;
  font-size: 12px;
  color: #6a6a6a;
  font-weight: 500;
`;
